import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute} from '@angular/router';
import {AccountService} from "../singelton/account.service";
import { Subject } from "rxjs";
@Component({
  selector: 'app-advanced-search-general',
  templateUrl: './advanced-search-general.component.html',
  styleUrls: ['./advanced-search-general.component.scss']
})
export class AdvancedSearchGeneralComponent implements OnInit {
  term:any='';
  term1:any='';
  // resetFormSubject: Subject<boolean> = new Subject<boolean>();
  resetFormSubject: Subject<boolean> = new Subject<boolean>();
  showWidget1 = true;
  showWidget2 = true;
  showWidget3 = true;
  showWidget4 = true;
  showWidget5 = true;
  showWidget6 = true;
  showWidget7 = true;
  showWidget8 = true;
  showWidget9 = true;

  constructor(
              private modalService: NgbModal,
              public accountService: AccountService, private router: Router,
              private toastr: ToastrService,
              protected activatedRoute: ActivatedRoute,
              private spinner: NgxSpinnerService) {
  }


  eventWidget1() {
    if (!this.showWidget1) {
      this.showWidget1 = true;
    } else {
      this.showWidget1 = false;

    }
  }
  eventWidget2() {
    if (!this.showWidget2) {
      this.showWidget2 = true;
    } else {
      this.showWidget2 = false;

    }
  }
  eventWidget3() {
    if (!this.showWidget3) {
      this.showWidget3 = true;
    } else {
      this.showWidget3 = false;

    }
  }
  eventWidget4() {
    if (!this.showWidget4) {
      this.showWidget4 = true;
    } else {
      this.showWidget4 = false;

    }
  }

  eventWidget5() {
    if (!this.showWidget5) {
      this.showWidget5 = true;
    } else {
      this.showWidget5 = false;

    }
  }
  eventWidget6() {
    if (!this.showWidget6) {
      this.showWidget6 = true;
    } else {
      this.showWidget6 = false;

    }
  }

  eventWidget7() {
    if (!this.showWidget7) {
      this.showWidget7 = true;
    } else {
      this.showWidget7 = false;

    }
  }

  eventWidget8() {
    if (!this.showWidget8) {
      this.showWidget8 = true;
    } else {
      this.showWidget8 = false;

    }
  }
  eventWidget9() {
    if (!this.showWidget9) {
      this.showWidget9 = true;
    } else {
      this.showWidget9 = false;

    }
  }
  resetChildForm() {
    this.resetFormSubject.next(true);
    // alert('this.term='+this.term)
    // alert('this.term1='+this.term1)
    // this.term= this.term1;

  }
  search25(){
    // alert('this.term='+this.term)
    // alert('this.term1='+this.term1)

    // this.term= this.term1;
    this.reloadComponent();
  }


  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.term = params['term'];
    })
  }
  reloadComponent() {
    // let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.router.onSameUrlNavigation = 'reload';
    // this.router.navigate([currentUrl]);
    // alert('term1==='+'/rapid-search/'+this.term)
    this.router.navigate(['/rapid-search/'+this.term])
  }

}
